import React, { useState } from "react";
import FullScreenDrawer from "@/components/FullScreenDrawer";
import { NavItem, SubMenu } from "./NavItem";
import NavDrawerFooter from "./NavDrawerFooter";
import DrawerHeader from "@/components/DrawerHeader";
import theme from "@/theme";
import { useMediaQuery } from "@mui/material";

export type NavDrawerProps = {
  isRoot?: boolean;
  customerName?: string;
  accountLink?: string;
  open: boolean;
  onBack?: () => void;
  onClose?: () => void;
} & SubMenu;

const NavDrawer = (props: NavDrawerProps) => {
  const {
    links,
    title,
    isRoot = false,
    customerName,
    accountLink,
    open,
    onClose,
    onBack,
  } = props;
  const fullScreen: boolean = useMediaQuery(theme.breakpoints.down(375));

  const [selectedSubMenu, setSelectedSubMenu] = useState<string | null>(null);

  const handleBack = () => {
    setSelectedSubMenu(null);
  };

  const handleClose = () => {
    setSelectedSubMenu(null);
    onClose?.();
  };

  return (
    <FullScreenDrawer
      data-id={`nav-drawer${title ? "-" + title.toLocaleLowerCase() : ""}`}
      anchor="left"
      open={open}
      onClose={onClose}
      fullscreen={fullScreen ? "true" : undefined}
      role="dialog"
      aria-label={title ? `${title} navigation` : "main navigation"}
      aria-modal={true}
      BackdropProps={
        !isRoot ? { style: { backgroundColor: "transparent" } } : {}
      }
    >
      {isRoot ? (
        <DrawerHeader handleClose={onClose} variant="light" />
      ) : (
        <DrawerHeader
          handleBack={onBack}
          handleClose={onClose}
          text={title}
          sticky
        />
      )}
      <div className="grid gap-8 p-8">
        {links.map((navItem, index) => {
          return navItem.type === "submenu" ? (
            <React.Fragment key={index}>
              <NavItem
                {...navItem}
                onSubmenuClick={() => setSelectedSubMenu(navItem.title)}
              />
              <NavDrawer
                open={selectedSubMenu === navItem.title}
                links={navItem.links}
                title={navItem.title}
                onBack={handleBack}
                onClose={handleClose}
              />
            </React.Fragment>
          ) : (
            <NavItem key={index} {...navItem} />
          );
        })}
      </div>
      {isRoot && (
        <NavDrawerFooter
          customerName={customerName}
          accountLink={accountLink}
        />
      )}
    </FullScreenDrawer>
  );
};

export { NavDrawer };
